import { take, put, call } from 'redux-saga/effects';
import { get } from '../../utils/api';
import settings from '../../utils/settings';
import {
  GET_APPLICATIONS_SITE_LIST_REQUEST,
  GET_APPLICATIONS_SITE_LIST_SUCCESS,
  GET_APPLICATIONS_SITE_LIST_FAILURE,
  SITE_SEARCH_REQUEST,
  SITE_SEARCH_REQUEST_SUCCESS,
  SITE_SEARCH_REQUEST_FAILURE
} from './constants';

export function* getSgipSiteListFlow() {
  while (true) {
    yield take(GET_APPLICATIONS_SITE_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.sgipUrl(`api/v1/sgip/sgip_sites`),
        withBearer: true
      });
      const { success, result } = response;
      if (success) {
        yield put({ type: GET_APPLICATIONS_SITE_LIST_SUCCESS, applicationSiteIds: result.site_ids });
      } else {
        yield put({ type: GET_APPLICATIONS_SITE_LIST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: GET_APPLICATIONS_SITE_LIST_FAILURE, error });
    }
  }
}

export function* getSiteSearchFlow() {
  while (true) {
    const request = yield take(SITE_SEARCH_REQUEST);
    try {
      let response;
      const { searchValue, searchType } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/sites/search?search_value=${encodeURI(searchValue)}&search_type=${encodeURI(searchType)}`)
      });
      if (response.success) {
        yield put({ type: SITE_SEARCH_REQUEST_SUCCESS, searchList: response.result });
      } else {
        yield put({ type: SITE_SEARCH_REQUEST_FAILURE, error: response.result.message });
      }
    } catch (error) {
      yield put({ type: SITE_SEARCH_REQUEST_FAILURE, error: error });
    }
  }
}
